var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrokenLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.38103 6.45832L5.95246 6.45833C3.91371 6.45833 2.29175 8.05985 2.29175 9.99801C2.29175 11.6688 3.49465 13.0875 5.13466 13.4492C5.397 13.507 5.67064 13.5377 5.95246 13.5377C6.29764 13.5377 6.57746 13.8175 6.57746 14.1627C6.57746 14.5079 6.29764 14.7877 5.95246 14.7877C5.57963 14.7877 5.21575 14.7471 4.8655 14.6698C2.68839 14.1898 1.04175 12.2913 1.04175 9.99801C1.04175 7.33599 3.25735 5.20833 5.95246 5.20833L7.38103 5.20832C10.0846 5.20832 12.2917 7.57984 12.2917 9.99801C12.2917 10.3432 12.0119 10.623 11.6667 10.623C11.3216 10.623 11.0417 10.3432 11.0417 9.99801C11.0417 8.2633 9.38733 6.45832 7.38103 6.45832Z",
    fill: "#656579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5092 13.4625C16.2772 13.2069 16.2964 12.8116 16.5521 12.5797C17.267 11.9309 17.7084 11.013 17.7084 9.998C17.7084 8.32725 16.5055 6.90848 14.8655 6.54685C14.6032 6.489 14.3295 6.45831 14.0477 6.45831C13.7025 6.45831 13.4227 6.17849 13.4227 5.83331C13.4227 5.48814 13.7025 5.20831 14.0477 5.20831C14.4205 5.20831 14.7844 5.24894 15.1347 5.32617C17.3118 5.80624 18.9584 7.70473 18.9584 9.998C18.9584 11.3862 18.3524 12.6339 17.392 13.5054C17.1364 13.7373 16.7412 13.7181 16.5092 13.4625Z",
    fill: "#656579"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2443 14.1627C13.2443 14.5079 12.9645 14.7877 12.6193 14.7877C9.91578 14.7877 7.70859 12.4162 7.70859 9.998C7.70859 9.65282 7.98841 9.373 8.33359 9.373C8.67877 9.373 8.95859 9.65282 8.95859 9.998C8.95859 11.7327 10.613 13.5377 12.6193 13.5377C12.9645 13.5377 13.2443 13.8175 13.2443 14.1627Z",
    fill: "#656579"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5581 14.558C14.8022 14.314 15.1979 14.314 15.442 14.558L16.7678 15.8839L18.0937 14.558C18.3378 14.314 18.7335 14.314 18.9776 14.558C19.2216 14.8021 19.2216 15.1979 18.9776 15.4419L17.6517 16.7678L18.9776 18.0936C19.2216 18.3377 19.2216 18.7334 18.9776 18.9775C18.7335 19.2215 18.3378 19.2215 18.0937 18.9775L16.7678 17.6516L15.442 18.9775C15.1979 19.2215 14.8022 19.2215 14.5581 18.9775C14.3141 18.7334 14.3141 18.3377 14.5581 18.0936L15.884 16.7678L14.5581 15.4419C14.3141 15.1979 14.3141 14.8021 14.5581 14.558Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenLink);
export default __webpack_public_path__ + "static/media/broken-link.590584a641ddb67692739bcdbbed8ee3.svg";
export { ForwardRef as ReactComponent };